import React from 'react';
import {useSingleTheme} from '../../components/hooks/hooks-mongoDB/useSingleTheme';
import {useArticles} from '../../components/hooks/hooks-mongoDB/useArticles';
import {useParagraphs} from '../../components/hooks/hooks-mongoDB/useParagraphs';
import ThemesScreen from '../../components/modules/pannelli/ThemesScreen';
import {TipHeadLinks} from '../../components/modules/pannelli/HeadLink';
import '../../components/modules/pannelli/themesScreen.scss';

function VinoRosso() {
    const {theme} = useSingleTheme('tipologia');
    const tipologia_Theme = theme;
    const {articles} = useArticles('tipologia');
    const article = articles.slice(1, 2) || [];
    const articles_VRosso = article[0] 
    const {paragraphs} = useParagraphs('tipologia_2');

    return (
        <section>
            {theme && <TipHeadLinks title={tipologia_Theme.tema_titolo} /> }
            <ThemesScreen theme={tipologia_Theme} article={articles_VRosso} paragraphs={paragraphs}/> 
        </section>
    )
}
export default VinoRosso;
